// extracted by mini-css-extract-plugin
export default {"image":"TooltopedImage_image__SFg4f"};